import React from 'react'

const SvgStarOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12.003 2c.96 0 1.589.406 1.888 1.218l1.367 4.465h4.911c.97.07 1.56.51 1.767 1.317.207.807-.089 1.56-.888 2.26L17.324 14l1.561 5.396c.307.868.092 1.586-.645 2.153-.737.568-1.548.593-2.431.076l-3.806-2.665-3.912 2.723c-1.016.463-1.84.419-2.472-.134-.632-.552-.833-1.248-.603-2.087L6.566 14l-3.608-2.74c-.787-.695-1.09-1.448-.906-2.26.183-.811.757-1.25 1.722-1.317h4.879l1.396-4.475C10.39 2.403 11.043 2 12.003 2zM4.04 9.678l4.935 3.726-1.97 6.57 5.04-3.61L17.06 20l-2.061-6.596 4.993-3.727h-5.96L12.029 4l-2.02 5.678H4.04z'
    />
  </svg>
)

export default SvgStarOutline
